// Product Compare Chart Module

// Attempt to get the element using document.getElementById
const comparetable = document.getElementById('comparetable');

// If it isn't "undefined" and it isn't "null", then it exists.
if (comparetable) {
	// On load
	// get the current table from table id, might be better to ID as table and get a data attr.
	// get prodid's from storage by comparegroup as key
	// on load populate each col with product into

	// on prod update
	// remove old product
	// fill prod col with new pro specs
	// update storage

	// global var for product data
	// var products;

	// get the comparegroup id for the table
	console.log('table ID:', comparetable);

	const { comparegroup } = comparetable.dataset; // string
	console.log('comparegroup:', comparegroup);

	// set prodducts to global var, don't realy need to do this, but it's a little cleaner
	const prodData = window.allProducts;
	console.log('prodData:', prodData);

	var prodData_ids = [];
	prodData.forEach((i) => {
		prodData_ids.push(i.id);
	})

	console.log('prod data ids', prodData_ids);

	// get array of prod ids as numbers from storage
	
	let myProd_ids = [];

	if (localStorage.getItem(comparegroup)) {
		myProd_ids = JSON.parse(localStorage
			.getItem(comparegroup))
			.map(Number);
		} 

	//Set height of product-brief
  const setProductCardAlignment = () => {
    const productSlots = document.querySelectorAll(
      ".prodslot[data-product]:not([data-product=''])"
    );
    if (productSlots.length === 0) return;

    let maxHeight = 0;
    let maxCtaBtnHeight = 0;
    let maxTitleHeight = 0;
    const productBriefs = [];
    const productTitles = [];
    const secondaryCtaPaddingTargets = [];

    // Find the maximum heights
    productSlots.forEach((slot) => {
      const productTitle = slot.querySelector(".product-title");
      const productBrief = slot.querySelector(".product-brief");
      const primaryCtaBtn = slot.querySelector(
        ".button.button--basic.button--purple"
      );
      const secondaryCtaBtn = slot.querySelector(
        ".button.button--text.button--purple"
      );

      if(productTitle) {
        const titleHeight = productTitle.offsetHeight;
        maxTitleHeight = Math.max(maxTitleHeight, titleHeight);
        productTitles.push(productTitle);
      }

      if (productBrief) {
        const height = productBrief.offsetHeight;
        maxHeight = Math.max(maxHeight, height);
        productBriefs.push(productBrief); // Store for batch update
      }

      if (primaryCtaBtn) {
        let secondaryBtnMarginTop = 15; // Default margin
        if (secondaryCtaBtn) {
          secondaryBtnMarginTop = parseInt(
            window.getComputedStyle(secondaryCtaBtn).marginTop
          );
        }
        maxCtaBtnHeight = Math.max(
          maxCtaBtnHeight,
          primaryCtaBtn.offsetHeight + secondaryBtnMarginTop
        );
      } else if (secondaryCtaBtn) {
        secondaryCtaPaddingTargets.push(
          secondaryCtaBtn.closest(".product-ctas")
        );
      }
    });

    // Apply the maximum heights in a single pass
    productTitles.forEach((title) => {
      title.style.height = `${maxTitleHeight}px`;
    });

    productBriefs.forEach((brief) => {
      brief.style.height = `${maxHeight}px`;
    });

    secondaryCtaPaddingTargets.forEach((target) => {
      if (target) target.style.paddingTop = `${maxCtaBtnHeight}px`;
    });

  };

	var remainingProds = filterProducts(prodData_ids, myProd_ids);

	function buildTable() {
	
		// create array of just prodData IDs to diff with myProd_ids
		const prodDataIDs = prodData.map((x) => x.id);

		// console.log('diff', differenceOf2Arrays(prodDataIDs, myProd_ids));
		const clean = myProd_ids.filter((x) => prodDataIDs.includes(x));
		localStorage.setItem(comparegroup, JSON.stringify(clean.map(String)));

		// For each stored prod, setup columns with prod id save col index
		//	// for each row, populate col of index

		// update array of prod ids
		myProd_ids = JSON.parse(localStorage
			.getItem(comparegroup))
			.map(Number);

		myProd_ids.forEach((myProd, index) => {
			// console.log('each myProd:', myProd);
			// console.log('each index:', index);

			const myProdData = prodData.find((obj) => obj.id === myProd);
			// console.log('each myProdData:', myProdData);

			// console.log('title:', myProdData.title);
			// console.log('brief:', myProdData.brief);

			// each spec
			const myProdSpecs = myProdData.specs;
			// console.log('myProdSpecs:', myProdSpecs);

			myProdSpecs.forEach((mySpec) => {
				// console.log('each mySpec:', mySpec);
				const myFeatureID = mySpec.feature;
				// console.log('each myFeatureID:', myFeatureID);
				const mySpecValue = mySpec.spec;
				// console.log('each mySpecValue:', mySpecValue);
				// let feature = 'prodfeature-' + element.feature;
				// let spec = element.spec;
				// let column = 2; //count index position form storage
				// document.querySelectorAll(`#comparetable[data-comparegroup='${comparegroup}']`)[0].rows.namedItem(feature).cells[column].innerHTML = spec;
			});

			// Add Stored products to Table
			// comparetable.rows.namedItem('headrow').cells[index+1].innerHTML = myProdData.title;
			const prodslot = document.getElementById(`prodslot-${index + 1}`);
			// console.log('prodslot:', prodslot);
			thContent = createProductDetails(myProdData);
			// prodslot.innerHTML = myProdData.title;
			prodslot.innerHTML = thContent;
			// add data-product attrgulp dev
			prodslot.dataset.product = myProd;

			// set spec value for each feature row
			const featureRows = document.querySelectorAll('[data-prodfeature]');
			// console.log('featureRows:', featureRows);

			featureRows.forEach((row) => {
				$rowData = row.getAttribute('data-prodfeature');

				myProdSpecs.forEach((arrayItem) => {
					if (arrayItem.feature == $rowData) {
						$spec = arrayItem.spec;
						row.cells[index + 1].innerHTML = $spec;
					}
				});
			});
		});
		setProductCardAlignment();
	}

	buildTable();

	document.addEventListener('click', (event) => {
		if (!event.target.matches('.remove-product')) return;
		event.preventDefault();
		removeProduct(event);
	});

	document.addEventListener('click', (event) => {
		if (!event.target.matches('#clear-all')) return;
		event.preventDefault();
		clearAll();
	});

	function removeProduct(event) {
		parentTh = event.target.closest('th');
		idToRemove = parentTh.getAttribute('data-product');

		const { cellIndex } = parentTh;

		const myProd_ids = JSON.parse(localStorage
			.getItem(comparegroup))
			.map(Number);

		const newArr = [];

		for (let i = 0; i < myProd_ids.length; i++) {
			if (myProd_ids[i] != idToRemove) {
				newArr.push(myProd_ids[i]);
			}
		}


		localStorage.setItem(comparegroup, JSON.stringify(newArr));

		//COMMENTED OUT IS FOR REMOVING PRODUCT FROM ONE COLUMN WIHTOUT MOVING REMAINING OVER
		// const featureRows = document.querySelectorAll('[data-prodfeature]');

		// featureRows.forEach((row) => {
		// 	row.children[cellIndex].innerHTML = '<center>&mdash;</center>';
		// });

		// const prodslots = document.getElementsByClassName('prodslot');

		// prodslots[cellIndex - 1].innerHTML = "<div class='product-title'>Add product<br> to compare</div><div class=' productlist-trigger plus-sign'>&#65291;</div>";

		//CLEAR TABLE
		const featureRows = document.querySelectorAll('[data-prodfeature]');

		featureRows.forEach((row) => {
			for (let i = 1; i < row.children.length; i++) {
				row.children[i].innerHTML = '<center>&mdash;</center>';
			}
		});

		const prodslots = document.getElementsByClassName('prodslot');

		for (let i = 0; i < prodslots.length; i++) {
			prodslots[i].innerHTML = "<div class='thcontent'><div class='product-title'>Add product<br> to compare</div><div class='productlist-trigger plus-sign'>&#65291;</div></div>";
		}

		// REBUILD THE TABLE
		let myProd_ids_remove = JSON.parse(localStorage
			.getItem(comparegroup))
			.map(Number);

		myProd_ids_remove.forEach((myProd, index) => {

			const myProdData = prodData.find((obj) => obj.id === myProd);
			// each spec
			const myProdSpecs = myProdData.specs;

			myProdSpecs.forEach((mySpec) => {
				const myFeatureID = mySpec.feature;
				const mySpecValue = mySpec.spec;
			
			});

			// Add Stored products to Table
			
			const prodslot = document.getElementById(`prodslot-${index + 1}`);

			thContent = createProductDetails(myProdData);
			// prodslot.innerHTML = myProdData.title;
			prodslot.innerHTML = thContent;
			// add data-product attrgulp dev
			prodslot.dataset.product = myProd;

			// set spec value for each feature row
			const featureRows = document.querySelectorAll('[data-prodfeature]');
			// console.log('featureRows:', featureRows);

			featureRows.forEach((row) => {
				$rowData = row.getAttribute('data-prodfeature');

				myProdSpecs.forEach((arrayItem) => {
					if (arrayItem.feature == $rowData) {
						$spec = arrayItem.spec;
						row.cells[index + 1].innerHTML = $spec;
					}
				});
			});
		});

		//CLEAR THE PRODUCT LIST
		const listwrapper = document.getElementById('productlist-list');
		while (listwrapper.firstChild) {
			listwrapper.removeChild(listwrapper.firstChild);
		}

		//ADD PRODUCT BACK TO LIST
		var prodData_ids = [];
		prodData.forEach((i) => {
			prodData_ids.push(i.id);
		})
	
		// get array of prod ids as numbers from storage
		let myProd_ids_new = JSON.parse(localStorage
			.getItem(comparegroup))
			.map(Number);
	
		var newRemainingProds = filterProducts(prodData_ids, myProd_ids_new);

		var remainingObjs = [];
		newRemainingProds.forEach((i) => {
			var result  = prodData.filter(function(o){return o.id == i;} );
			Array.prototype.push.apply(remainingObjs, result);
		})
		
		remainingObjs.forEach((j) => {
			var appendingHTML = `<div class="productlist-product" data-id="` + j.id + `">
				<div class="product-left">
					<span>` + j.title + `</span><br>` + j.brief + `</div>
				<div class="product-right">
					<div class="productright-wrapper">
						<p class="trigger-add">Add to compare </p><div class="plus trigger-add">+</div>
					</div>
				</div>
				<hr>
		</div>`
			listwrapper.innerHTML = listwrapper.innerHTML + appendingHTML;
		})

		setProductCardAlignment();
	}

	function clearAll() {
		const newArr = [];

		localStorage.setItem(comparegroup, JSON.stringify(newArr));

		const featureRows = document.querySelectorAll('[data-prodfeature]');

		featureRows.forEach((row) => {
			for (let i = 1; i < row.children.length; i++) {
				row.children[i].innerHTML = '<center>&mdash;</center>';
			}
		});

		const prodslots = document.getElementsByClassName('prodslot');

		for (let i = 0; i < prodslots.length; i++) {
			prodslots[i].innerHTML = "<div class='thcontent'><div class='product-title'>Add product<br> to compare</div><div class='productlist-trigger plus-sign'>&#65291;</div></div>";
		}


		//CLEAR THE PRODUCT LIST
		const listwrapper = document.getElementById('productlist-list');
		while (listwrapper.firstChild) {
			listwrapper.removeChild(listwrapper.firstChild);
		}

		//REBUILD THE PRODUCT LIST WITH ALL PRODUCTS
		prodData.forEach((j) => {
			var appendingHTML = `<div class="productlist-product" data-id="` + j.id + `">
				<div class="product-left">
					<span>` + j.title + `</span><br>` + j.brief + `</div>
				<div class="product-right">
					<div class="productright-wrapper">
						<p class="trigger-add">Add to compare </p><div class="plus trigger-add">+</div>
					</div>
				</div>
				<hr>
		</div>`
			listwrapper.innerHTML = listwrapper.innerHTML + appendingHTML;
		})
	}

	//No Product Message if none available
	function alertNoProducts() {
		const productCount = document.getElementsByClassName('productlist-product').length;
		let noProductDiv = document.getElementById('no-products-message');
		if (productCount < 1) {	
			noProductDiv.classList.add('show');
		} else {
			noProductDiv.classList.remove('show');
		}
	}

	// trigger product list and click off list
	document.addEventListener('click', (event) => {
		const productlist = document.getElementById('productcomparechart-list');
		var isClickInside = productlist.contains(event.target);

		if (event.target.matches('.productlist-trigger')) {
			positionList(event);
		} else {
			if (!isClickInside) {
				productlist.classList.remove('active');
				if (productlist.style.removeProperty) {
					productlist.style.removeProperty('left');
					productlist.style.removeProperty('top');
				} else {
					productlist.style.removeAttribute('left');
					productlist.style.removeAttribute('top');
				}
			}	
		}
		alertNoProducts();
	}, false);

	//close product list with X
	document.addEventListener('click', (event) => {
		var productlist = document.getElementById('productcomparechart-list');
		if (!event.target.matches('.productlist-close')) return;
		event.preventDefault();
		productlist.classList.remove('active');
		if (productlist.style.removeProperty) {
			productlist.style.removeProperty('left');
			productlist.style.removeProperty('top');
		} else {
			productlist.style.removeAttribute('left');
			productlist.style.removeAttribute('top');
		}
	});

	//position product list on appear
	function positionList(e) {

		var viewportWidth = window.innerWidth || document.documentElement.clientWidth;

		var productlist = document.getElementById('productcomparechart-list');

		if (viewportWidth > 1230) {
			var x;
			var y;
			if (e.pageX || e.pageY) { 
				x = e.pageX;
				y = e.pageY;
			  }
			  else { 
				x = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft; 
				y = e.clientY + document.body.scrollTop + document.documentElement.scrollTop; 
			  } 
			  x = x-490;
			  y = y-500;
	  
			  productlist.style.left = x+'px';
			  productlist.style.top = y+'px';
		} 

		if (!productlist.classList.contains('active')) {
			productlist.className += ' active';
		}
	}

	//filter out products for list that are already on chart
	function filterProducts(a1, a2) {
		var a = [], diff = [];

		for (var i = 0; i < a1.length; i++) {
			a[a1[i]] = true;
		}
	
		for (var i = 0; i < a2.length; i++) {
			if (a[a2[i]]) {
				delete a[a2[i]];
			} else {
				a[a2[i]] = true;
			}
		}
	
		for (var k in a) {
			diff.push(k);
		}
		return diff;
	}

	//build product list from products not on chart
	function buildProductlist() {
		const listwrapper = document.getElementById('productlist-list');
		var remainingObjs = [];
		remainingProds.forEach((i) => {
			var result  = prodData.filter(function(o){return o.id == i;} );
			Array.prototype.push.apply(remainingObjs, result);
		})
		
		remainingObjs.forEach((j) => {
			var appendingHTML = `<div class="productlist-product" data-id="` + j.id + `">
				<div class="product-left">
					<span>` + j.title + `</span><br>` + j.brief + `</div>
				<div class="product-right">
					<div class="productright-wrapper">
						<p class="trigger-add">Add to compare </p><div class="plus trigger-add">+</div>
					</div>
				</div>
				<hr>
		</div>`
			listwrapper.innerHTML = listwrapper.innerHTML + appendingHTML;
		})
	}

  function createProductDetails(product) {
    productButton = `${(product.openAccount && webbnData.user.country === 'US') ? `<a class='button button--basic button--purple' href='${product.openAccount}'>Open Account</a><br/><a class='button button--text button--purple' style="margin-top: 15px;" ` : "<a class='button button--text button--purple' "}href='${product.link}'>Learn More</a>`;
    let productDetails = `
      <div class="thcontent">
      <a class="remove-product">Remove<span class="remove-x">&nbsp;&nbsp;&#215;</span></a>
        <div class="product-title">${product.title}</div>
        <div class="product-brief">${product.brief}</div>
        <div class="product-ctas">
        ${productButton}
        </div>
      </div>
    `;

    return productDetails;
  }

	// add product to chart from list
	document.addEventListener('click', (e) => {
		const matches = e.target.matches ? e.target.matches('.trigger-add') : e.target.msMatchesSelector('.button-login-desktop');
		if (!matches) return;
		e.preventDefault();

		var attribute = e.target.closest(".productlist-product").getAttribute("data-id");

		myProd_ids = JSON.parse(localStorage
			.getItem(comparegroup))
			.map(Number);

		// create array of just prodData IDs to diff with myProd_ids
		var prodDataIDs = prodData.map((x) => x.id);

		// console.log('diff', differenceOf2Arrays(prodDataIDs, myProd_ids));
		const clean = myProd_ids.filter((x) => prodDataIDs.includes(x));
		clean.push(parseInt(attribute));
		localStorage.setItem(comparegroup, JSON.stringify(clean.map(String)));


		//CLEAR TABLE
		const featureRows = document.querySelectorAll('[data-prodfeature]');

		featureRows.forEach((row) => {
			for (let i = 1; i < row.children.length; i++) {
				row.children[i].innerHTML = '<center>&mdash;</center>';
			}
		});

		const prodslots = document.getElementsByClassName('prodslot');

		for (let i = 0; i < prodslots.length; i++) {
			prodslots[i].innerHTML = "<div class='thcontent'><div class='product-title'>Add product<br> to compare</div><div class='productlist-trigger plus-sign'>&#65291;</div></div>";
		}

		// REBUILD THE TABLE
		myProd_ids = JSON.parse(localStorage
			.getItem(comparegroup))
			.map(Number);

		myProd_ids.forEach((myProd, index) => {

			const myProdData = prodData.find((obj) => obj.id === myProd);
			// each spec
			const myProdSpecs = myProdData.specs;

			myProdSpecs.forEach((mySpec) => {
				const myFeatureID = mySpec.feature;
				const mySpecValue = mySpec.spec;
			
			});

			// Add Stored products to Table
			
			const prodslot = document.getElementById(`prodslot-${index + 1}`);

			thContent = createProductDetails(myProdData);
			// prodslot.innerHTML = myProdData.title;
			prodslot.innerHTML = thContent;
			// add data-product attrgulp dev
			prodslot.dataset.product = myProd;

			// set spec value for each feature row
			const featureRows = document.querySelectorAll('[data-prodfeature]');
			// console.log('featureRows:', featureRows);

			featureRows.forEach((row) => {
				$rowData = row.getAttribute('data-prodfeature');

				myProdSpecs.forEach((arrayItem) => {
					if (arrayItem.feature == $rowData) {
						$spec = arrayItem.spec;
						row.cells[index + 1].innerHTML = $spec;
					}
				});
			});
		});

		//CLOSE THE LIST
		const productlist = document.getElementById('productcomparechart-list');
		productlist.classList.remove('active');
		if (productlist.style.removeProperty) {
			productlist.style.removeProperty('left');
			productlist.style.removeProperty('top');
		} else {
			productlist.style.removeAttribute('left');
			productlist.style.removeAttribute('top');
		}

		//CLEAR THE PRODUCT LIST
		const listwrapper = document.getElementById('productlist-list');
		while (listwrapper.firstChild) {
			listwrapper.removeChild(listwrapper.firstChild);
		}

		//REFILTER and REBUILD THE PRODUCT LIST
	
		var prodData_ids = [];
		prodData.forEach((i) => {
			prodData_ids.push(i.id);
		})
	
		// get array of prod ids as numbers from storage
		let myProd_ids_new = JSON.parse(localStorage
			.getItem(comparegroup))
			.map(Number);
	
		var newRemainingProds = filterProducts(prodData_ids, myProd_ids_new);

		var remainingObjs = [];
		newRemainingProds.forEach((i) => {
			var result  = prodData.filter(function(o){return o.id == i;} );
			Array.prototype.push.apply(remainingObjs, result);
		})
		
		remainingObjs.forEach((j) => {
			var appendingHTML = `<div class="productlist-product" data-id="` + j.id + `">
				<div class="product-left">
					<span>` + j.title + `</span><br>` + j.brief + `</div>
				<div class="product-right">
					<div class="productright-wrapper">
						<p class="trigger-add">Add to compare </p><div class="plus trigger-add">+</div>
					</div>
				</div>
				<hr>
		</div>`
			listwrapper.innerHTML = listwrapper.innerHTML + appendingHTML;
		})

	setProductCardAlignment();

	}, false);

	buildProductlist();


	function ready() {
		var box = document.getElementById('headrow'),
			top = box.offsetTop + 200;
	
		function scroll(event) {
			var y = document['documentElement' || 'body'].scrollTop;
			if (y >= top) {
				box.classList.add('stick');
				setStickyHeadrowPosition();
			} else {
				box.classList.remove('stick');
				setStickyHeadrowPosition();
			}
		}
	
		window.addEventListener('scroll', scroll);
		window.addEventListener('resize', setStickyHeadrowPosition);
	}
	
	if (document.readyState == 'complete' || document.readyState == 'loaded') {
		ready();
		setStickyHeadrowPosition();
	} else {
		window.addEventListener('DOMContentLoaded', function() {
			ready();
			setStickyHeadrowPosition();
		});
	}

	// This function sets the 'top' property of the sticky headrow (#headrow.stick)
	// to match the height of the site header (header.siteheader). This ensures that
	// when the headrow becomes sticky, it is positioned just below the site header,
	// regardless of the header's height (which may change on window resize).
	// The function is called on scroll (when sticky state changes), on window resize,
	// and on DOMContentLoaded to keep the alignment correct.
	function setStickyHeadrowPosition() {
		const siteHeader = document.querySelector('header.siteheader');
		// More accurate variable name for sticky headrow elements
		const stickyHeadrows = document.querySelectorAll('#headrow.stick');
		if (!siteHeader || stickyHeadrows.length === 0) return;

		const headerHeight = siteHeader.offsetHeight;
		stickyHeadrows.forEach(stickyHeadrow => {
			stickyHeadrow.style.top = `${headerHeight}px`;
		});
	}
}
